module.exports = __webpack_public_path__ + "img/square-d.83538f14.svg";